import React, { useContext, useEffect, useRef, useState } from "react";
import MapContext from "../../../MapContext";
import { useSelector, useDispatch } from "react-redux";
import "../Results.css";
import { Point } from "ol/geom.js";
import { setResultsData } from "../../../../redux/resultsSlice";
import { doesIntersect, bufferGeometry } from "../../../utils/mapUtils";

const MapTipsOptions = () => {
    const { map } = useContext(MapContext);
    const vectorLayers = useSelector((state) => state.configData.vectorLayerProperties);
    const activeTool = useSelector((state) => state.toolSelect.tool);
    const [activeMapTipsTool, setActiveMapTipsTool] = useState(false);
    const dispatch = useDispatch();

    // Identify on click
    const identifyOnClick = (e) => {
        // Get coordinate from pixel and create point geometry
        const viewPortPixel = map.getEventPixel(e.originalEvent);
        const mapPixel = map.getCoordinateFromPixel(viewPortPixel);
        const point = new Point(mapPixel);
        // Add a default 3 px buffer
        const threePxBuffer = map.getView().getResolution() * 3;
        const geometry = bufferGeometry(point, null, threePxBuffer);
        setIntersectingFeatures(geometry);
    };

    // This function is more else the same from Identity Options
    // Take a geometry and tests if all 'ShowMapTips' layers on the map intersect
    // sets intersecting features to state
    const setIntersectingFeatures = (geometry) => {
        const extent = geometry.getExtent();
        const allLayers = map.getAllLayers();
        const layers = [];
        allLayers.forEach((layer) => {
            const isVisible = layer.getVisible();
            const layerId = layer.values_.Id;
            // match layer from map to saved config data in state
            const matchedLayer = vectorLayers.find((mapLayer) => mapLayer.Id === layerId);
            // check to see if it was in state and is ShowMapTips
            if (matchedLayer && matchedLayer.ShowMapTips === true && isVisible) {
                // create array for storing the id of each feature in extent
                const featureIds = [];
                const featuresInExtent = layer.getSource().getFeaturesInExtent(extent);
                featuresInExtent.forEach((feature) => {
                    const intersection = doesIntersect(feature, geometry); // returns boolean
                    // if there is an intersection push the feature id to the array
                    if (intersection === true) {
                        featureIds.push(feature.id_);
                    }
                });
                // if there were intersections between features in layer and test geometry
                // create object with data from matched layer in state
                // with an array of the features that intersected
                if (featureIds.length > 0) {
                    const layerObj = {
                        DisplayName: matchedLayer.DisplayName,
                        FeatureLabel: matchedLayer.FeatureLabel,
                        FeatureDescription: matchedLayer.FeatureDescription,
                        Id: matchedLayer.Id,
                        Features: featureIds,
                    };
                    layers.push(layerObj);
                }
            }
        });
        dispatch(setResultsData(layers));
    };
    // Handle changing of active identify tool
    useEffect(() => {
        if (!activeMapTipsTool || !map) return;
        // activate click on UI
        if (activeMapTipsTool === "click") {
            map.on("click", identifyOnClick);
        } else {
            map.un("click", identifyOnClick);
        }
        return () => {
            map.un("click", identifyOnClick);
        };
    }, [activeMapTipsTool, activeTool, map]);

    // Check what tool is active and switch off Map Tips when appropriate
    useEffect(() => {
        //No tool selected so the map is defaulted to pan
        if (!activeTool) {
            setActiveMapTipsTool("click");
        } else if (activeTool === "pan") {
            setActiveMapTipsTool("click");
        }
        // All other tools turn off map tips
        else {
            setActiveMapTipsTool();
        }
    }, [activeTool]);

    return <></>;
};

export default MapTipsOptions;
